export enum AuditLogLevel {
  Repository = 'repository',
  Team = 'team'
}
